import React from 'react';
import CustomCard from './CustomCard';
import useTranslation from '../hooks/useTranslation';

const TranslatedJobCard = ({ job, onMoreClick }) => {
  const { title, description } = useTranslation(job.id, job.title, job.description || job.description_short);

  return (
    <CustomCard
      id={job.id}
      image={job.image_url}
      title={title}
      description={description}
      salary={job.salary}
      city={job.location || job.city}
      dateAdded={job.date_added}
      company={job.company}
      category={job.category}
      onMoreClick={() => onMoreClick(job.id)}
    />
  );
};

export default TranslatedJobCard;
